import consts from "shared/consts";
import { atom } from "jotai";
import { selectedElementIdsAtom } from "state-atoms";
import { isIdOfType } from "../../canvas-elements-utils";
import { DefaultNodeStyle } from "./consts";
import { DRAW_PROPS_ID } from "shared/datamodel/schemas/org-chart";
import { Sizes } from "frontend/data/shapes/sizes";

export function getNodeDrawProps(element: any, nodeId: string) {
  return Object.assign(
    {},
    DefaultNodeStyle,
    { lineWidth: Sizes.get().orgChart.lineWidth },
    element?.data?.[nodeId]?.[DRAW_PROPS_ID]
  );
}

export function arrayEq<T>(a: T[], b: T[]) {
  return a.length == b.length && a.every((v) => b.includes(v));
}

export const isOrgChartRootSelectedAtom = atom((get) =>
  get(selectedElementIdsAtom).some((id: string) => isIdOfType(id, consts.CANVAS_ELEMENTS.ORG_CHART))
);
